import React from 'react'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'

const BleedControlled = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>Bleeding Controlled</InputLabel>
      <Select
        value={moduleValues?.['Bleeding Controlled'] ?? ''}
        label="Bleeding Controlled"
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Bleeding Controlled']: e.target.value,
          }))
        }
      >
        {['Yes', 'No'].map((x) => (
          <MenuItem key={x} value={x}>
            {x}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)

export default BleedControlled
